/**
 * @file hooks/customEqual
 * @author zhangzhe(zhangzhe@baidu.com)
 */

import {useRef} from 'react';
import {isEqualWith} from 'lodash';

// 这个其实等同于@huse/previous-value库的useOriginalDeepCopy
export const useOriginalCopy = <T>(value: T, customEvent?: (savedValue: T, value: T) => boolean): T => {
    const copy = useRef(value);

    if (!isEqualWith(copy.current, value, customEvent)) {
        copy.current = value;
    }
    return copy.current;
};
